import axios, { AxiosResponse } from "axios"
import {
  adapterAfterbanksConsent,
  adapterAfterbanksSupportedBanks,
} from "./Afterbanks.adapter"
import { ConsentDtoProps } from "./DTOs/ConsentDto"
import { GetAllSupportedBanksDtoProps } from "./DTOs/GetAllSupportedBanksDto"
import { GetEmpresaActivaUsuarioDtoProps } from "./DTOs/GetEmpresaActivaUsuarioDto"
import { GetUsuarioLoggedDtoProps } from "./DTOs/GetUsuarioLoggedDto"

const BASE_URL: string = import.meta.env.REACT_APP_API_AFTERBANKS

// Exported variable 'useBankListFromAfterbanks' is using name 'AfterBanksResponseProps' from this module
export interface AfterBanksResponseProps {
  country_code?: string
  service?: string
  swift?: string
  fullname?: string
  business?: string
  PDF?: string
  documenttype?: string
  user?: string
  pass?: string
  pass2?: string
  pass3?: string
  userdesc?: string
  passdesc?: string
  pass2desc?: string
  pass3desc?: string
  usertype?: string
  passtype?: string
  pass2type?: string
  pass3type?: string
  image?: string
  imageSVG?: string
  color?: string
}
export async function getBankListFromAfterbanks(): Promise<
  Array<AfterBanksResponseProps>
> {
  const service = axios.create({
    baseURL: "https://api.afterbanks.com",
  })
  const { data } = await service.get("/V3/forms/?country_code=es")
  return data
}

interface AfterBanksSecondResponseProps {
  balance: number
  currency: string
  description: string
  product: string
  type: string
}
interface AccountProps {
  accountId: number
  description: string
}
interface AdditionalInfoProps {
  accounts: Array<AccountProps>
  otp?: Record<string, string>
  products?: Array<AfterBanksSecondResponseProps>
}
interface AfterBanksAuthorizeResponseProps {
  additionalInfo: AdditionalInfoProps
  code: number
  longCode: number
  message: string
}
export async function authorizeAccountAfterbanks(
  requestBody?: Record<string, string | number | AfterBanksSecondResponseProps>
): Promise<AxiosResponse<AfterBanksAuthorizeResponseProps>> {
  const response = await axios.post(
    `${BASE_URL}/BankAccount/authorize`,
    requestBody
  )
  return response
}

export async function getAfterbanksSupportedBanks(
  countryCode: string
): Promise<GetAllSupportedBanksDtoProps[]> {
  const { data } = await axios.get(`${BASE_URL}/PSD2/supported-banks`, {
    params: countryCode,
  })
  return data.map((bank: GetAllSupportedBanksDtoProps) =>
    adapterAfterbanksSupportedBanks(bank)
  )
}

interface AfterbanksConsentQueryParamsProps {
  Iban: string
  Service: string
  UrlRedirect: string
  UserIdentityId: GetUsuarioLoggedDtoProps["identityId"]
  NifCompany: GetEmpresaActivaUsuarioDtoProps["nif"]
  IsTransactionSyncEnabled: boolean
}

export async function getAfterbanksConsent(
  queryParams: AfterbanksConsentQueryParamsProps
): Promise<ConsentDtoProps> {
  const { data } = await axios.get(`${BASE_URL}/PSD2/consent`, {
    params: queryParams,
  })
  return adapterAfterbanksConsent(data)
}
